function Home() {
    return (
        <div>
            <h2>Home View</h2>
            {/* Add more content for your Home view here */}
        </div>
    );
}

export default Home;